import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueSanitize from 'vue-sanitize';
import config from '@/config';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  events: 'change|blur',
  useConstraintAttrs: false, // allows for validation of disabled fields
});

Vue.use(VueSanitize, config.sanitizeSettings);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
